import { progressStore } from 'stores';

import { DASHBOARD_STATES } from '../constants/dashboard.constants';

import { DashboardService } from '../services/dashboard.service';
import { dashboardRaceService } from '../services/races.service';

import { DashboardStore } from '../stores/dashboard.store';

export async function loadRegistrations(forceLoad = false, skipRaces = false) {
  if (forceLoad || !DashboardStore.registrations.value) {
    if (!skipRaces) {
      await dashboardRaceService.loadRaces(true, 1);
    }

    try {
      progressStore.log(DASHBOARD_STATES.REGISTRATIONS_LOADING, 'progress');
      await DashboardService.loadRegistrationsData();
    } catch (error) {
    } finally {
      progressStore.log(DASHBOARD_STATES.REGISTRATIONS_LOADING, 'completed');
    }
  }
}
